import env from '../env';
import axios from 'axios';

class OrganizationMemberService {
  static async updateSetting(setting) {
    return await axios.put(`${env.health_backend}settings/${setting.id}`, setting);
  }
  
}
export default OrganizationMemberService